var _metadata, _defs, _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgItem5Ar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    x: 0,
    y: 0,
    style: {
      enableBackground: "new 0 0 750 289"
    },
    viewBox: "0 0 750 289",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata71"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs69"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", {
    id: "style2"
  }, "\n    .st1{fill:#fff}.st2{fill:#666}.st3{fill:#7f7f7f}.st4{fill:#000}.st5{font-size:14.3971px}.st6{fill:#369;fill-opacity:.502}.st7{font-family:'ArialUnicodeMS'}.st8{font-size:11.4815px}\n  ")), /*#__PURE__*/React.createElement("path", {
    d: "M750 0H0v289.4h750V0z",
    style: {
      fill: "none"
    },
    id: "path4"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M255.3 153.4v-40.7h-77.1v40.7h77.1z",
    className: "st1",
    id: "path6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M256 154.2v-42h-78.4v42H256m-1.3-40.7v39.3h-75.8v-39.3h75.8z",
    id: "path8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M256 194.3v-40.4h-77.1v40.4H256z",
    className: "st2",
    id: "path10"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M256 194.3v-41.7h-78.4v41.7H256m-1.3-40.4V193h-75.8v-39.1h75.8z",
    id: "path12"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M232.3 85.3v-4.1h-31.1v4.1h2.5V95c0 1.5-.8 3.1-2.6 4.7-3 2.6-6.7 4.8-11.1 6.6-4.5 1.8-8.2 2.7-10.9 2.8h-.3l-.1.1c-1.8.5-2.8 1.7-3 3.6V196h81.8v-83.2c-.2-1.9-1.2-3.1-3-3.6l-.1-.1h-.3c-1.8 0-4-.5-6.7-1.3-4.3-1.4-8.3-3.2-12.1-5.7-1.8-1.1-3.2-2.3-4.2-3.6-1.1-1.3-1.6-2.5-1.6-3.6v-9.7l2.8.1m-1.3-2.7V84h-2.5v11.1c0 2 1.1 3.9 3.2 5.7 3 2.8 6.8 5.1 11.4 6.8 4.3 1.7 8 2.7 11.1 2.9h.1c1.3.3 2 1.1 2.1 2.4v81.8h-79.2v-81.8c.1-1.3.8-2.1 2.1-2.4h.3c1.8-.1 4.1-.6 6.7-1.4 4.4-1.3 8.5-3.2 12.4-5.7 1.8-1.3 3.4-2.6 4.6-3.9 1.2-1.4 1.8-2.9 1.8-4.3V84h-2.5v-1.4H231z",
    id: "path14"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.99904953,1.0009514)",
    id: "text16",
    style: {
      fontSize: "14.3971px",
      fontFamily: "ArialUnicodeMS",
      direction: "rtl",
      fill: "#000000",
      strokeWidth: 0.99905
    },
    className: "st4 st5 st7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 228.3398,138.74202 h -1.35417 q -0.8724,0 -1.96615,-0.39063 -1.26302,-0.45573 -2.22656,-1.25 -0.75521,0.92448 -1.54949,1.28907 -0.78125,0.35156 -2.29167,0.35156 h -2.03125 v -2.26563 h 1.99219 q 1.1849,0 2.10938,-0.59896 0.71615,-0.46875 1.30208,-1.3151 0.79428,-1.14584 1.95313,-1.99219 1.04167,-0.75521 1.91407,-0.96355 0.89844,1.36719 1.43229,2.46094 0.71615,1.48438 0.71615,2.40886 z m -1.4974,-2.56511 q -0.16927,-0.75521 -0.52083,-1.48437 -0.29948,-0.61198 -0.79428,-1.26303 -0.625,0.15625 -1.05468,0.58594 -0.28646,0.27344 -0.67709,0.92448 0.46875,0.50781 1.31511,0.91146 0.85937,0.40365 1.61458,0.49479 z",
    style: {
      fontSize: "26.6667px"
    },
    id: "path118"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 217.83197,138.74202 h -1.82291 q -0.88542,0 -1.41928,-0.71615 -0.46875,-0.625 -0.71614,-1.86198 -0.23438,-1.23698 -0.36459,-3.04688 -0.0781,-1.47135 -0.16927,-3.02083 -0.0781,-1.54949 -0.22135,-2.34376 -0.13021,-0.80729 -0.36459,-1.3151 -0.28646,-0.625 -0.79427,-1.09375 l 1.60157,-2.52605 q 0.50781,1.5625 0.71614,3.73698 0.13021,1.35417 0.26042,6.40626 0.23437,2.31771 0.67708,2.96876 0.36459,0.54687 0.79428,0.54687 h 1.82291 z",
    style: {
      fontSize: "26.6667px"
    },
    id: "path120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 210.39707,135.56493 -0.625,2.13542 q -1.97917,0.49479 -3.25522,1.10677 -1.47135,0.70313 -2.68229,1.83594 l -0.40365,-0.22135 q 0.16927,-0.59896 0.45573,-1.10677 0.2474,-0.44271 0.57292,-0.79427 l -1.51042,-0.85938 q -0.66406,-0.44271 -0.66406,-0.96354 0,-0.41667 0.52083,-1.51042 0.625,-1.30209 1.4323,-2.17448 1.04166,-1.1198 2.09635,-1.1198 0.97657,0 1.61459,0.5599 0.14323,0.11719 0.66406,0.71615 l -0.67708,1.70573 q -0.48177,-0.32552 -0.57292,-0.39063 -0.79427,-0.50781 -1.30209,-0.50781 -0.625,0 -1.30208,0.35156 -0.67708,0.35156 -0.67708,0.79427 0,0.53386 0.78125,1.02865 0.61198,0.37761 1.84896,0.82031 1.8099,-0.87239 3.6849,-1.40625 z",
    style: {
      fontSize: "26.6667px"
    },
    id: "path122"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.99904953,1.0009514)",
    id: "text18",
    style: {
      fontSize: "26.6667px",
      fontFamily: "ArialUnicodeMS",
      direction: "rtl",
      fill: "#000000",
      strokeWidth: 0.99905
    },
    className: "st4 st5 st7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 233.87405,174.38356 q 0,1.43229 -1.22396,2.96875 -1.06771,1.35417 -2.65626,2.33074 -1.51041,0.9375 -2.48698,0.9375 -0.89844,0 -1.94011,-0.26042 -0.79427,-0.19531 -1.90104,-0.61198 -0.9375,-0.35156 -1.86198,-0.70313 l 0.22135,-0.52083 q 0.85938,0.16927 1.78386,0.33854 0.9375,0.18229 1.69271,0.18229 1.66667,0 3.47657,-1.06771 1.64062,-0.97656 2.79948,-2.46094 1.15886,-1.49739 1.15886,-2.69531 0,-1.02865 -0.59896,-2.16146 -0.48177,-0.91146 -1.35417,-1.875 l 0.74219,-2.04428 q 1.06771,0.98959 1.57552,1.97917 0.57292,1.11979 0.57292,2.5 z m -1.94011,-12.12241 -1.01563,1.88802 -2.10937,-1.09375 0.96354,-1.90104 z",
    style: {
      fontSize: "26.6667px",
      fontFamily: "ArialUnicodeMS",
      direction: "rtl",
      fill: "#000000",
      strokeWidth: 0.99905
    },
    id: "path125"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 220.84018,174.38356 h -7.42189 v -2.26563 h 6.47136 q 0,-1.53646 -0.36458,-2.34375 -0.2474,-0.5599 -1.22396,-1.61459 l 1.01563,-2.12239 q 0.9375,1.18489 1.17187,1.84896 0.35157,1.0026 0.35157,3.32031 z m -0.11719,2.57813 -0.96354,1.88802 -2.13542,-1.09375 0.98958,-1.88802 z m -2.96876,1.21094 -0.97656,1.86198 -2.14844,-1.10677 1.01563,-1.87501 z",
    style: {
      fontSize: "26.6667px",
      fontFamily: "ArialUnicodeMS",
      direction: "rtl",
      fill: "#000000",
      strokeWidth: 0.99905
    },
    id: "path127"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 214.32975,174.38356 h -12.42189 q -2.5,0 -3.98438,-0.8724 -1.86198,-1.09375 -1.86198,-3.42448 0,-1.21094 0.54688,-2.47396 0.19531,-0.45573 0.9375,-1.73177 l 0.39062,0.24739 q -0.28646,0.59896 -0.55989,1.19792 -0.37761,0.92448 -0.37761,1.65365 0,1.53646 1.61459,2.38281 1.44531,0.75521 3.65886,0.75521 h 11.02866 v -0.35156 q 0,-1.45834 -0.35157,-2.3698 -0.35156,-0.92448 -1.19792,-1.57552 l 1.00261,-2.1224 q 0.57292,0.71615 0.69011,0.89844 0.88541,1.45834 0.88541,4.2448 z m -6.13282,-11.83595 -0.96354,1.88802 -2.13542,-1.09375 0.98958,-1.88802 z m -2.96875,1.21094 -0.97656,1.86198 -2.14845,-1.10677 1.01563,-1.87501 z",
    style: {
      fontSize: "26.6667px",
      fontFamily: "ArialUnicodeMS",
      direction: "rtl",
      fill: "#000000",
      strokeWidth: 0.99905
    },
    id: "path129"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M226.6 88.5l1.6-3.9h-22.8l1.1 3.9h20.1z",
    className: "st3",
    id: "path20"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M413.9 153.5v-40.7h-77.2v40.7h77.2z",
    className: "st2",
    id: "path22"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M414.6 154.2v-42H336v42h78.6m-1.4-40.7v39.3h-75.9v-39.3h75.9z",
    id: "path24"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M413.9 193.6v-40.4h-77.2v40.4h77.2z",
    className: "st1",
    id: "path26"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M414.6 194.3v-41.7H336v41.7h78.6m-1.4-40.4V193h-75.9v-39.1h75.9z",
    id: "path28"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M388.2 85.3h2.5v-4.1h-31.1v4.1h2.6V95c-.1 1.5-1 3.1-2.8 4.7-2.9 2.6-6.6 4.8-11.1 6.6-4.5 1.8-8.1 2.7-10.8 2.8h-.4l-.1.1c-1.8.5-2.7 1.7-2.8 3.6V196h81.7v-83.2c-.1-1.9-1.1-3.1-2.9-3.6l-.1-.1h-.3c-1.7 0-3.9-.5-6.7-1.3-4.2-1.4-8.2-3.2-12.1-5.7-1.8-1.1-3.2-2.3-4.2-3.6-1.1-1.3-1.6-2.5-1.6-3.6v-9.6m1.4-2.7V84h-2.5v11.1c.1 2 1.2 3.9 3.2 5.7 3.1 2.8 6.9 5.1 11.4 6.8 4.4 1.7 8.1 2.7 11.1 2.9h.3c1.2.3 1.8 1.1 2 2.4v81.8h-79.1v-81.8c0-1.3.7-2.1 2-2.4h.3c1.9-.1 4.2-.6 6.8-1.4 4.3-1.3 8.5-3.2 12.4-5.7 1.8-1.3 3.4-2.6 4.6-3.9 1.1-1.4 1.8-2.9 1.8-4.3V84H361v-1.4h28.4z",
    id: "path30"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M385.1 88.5l1.7-3.9h-22.9l1.1 3.9h20.1z",
    className: "st3",
    id: "path32"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.99904953,1.0009514)",
    id: "text34",
    style: {
      fontSize: "14.3971px",
      fontFamily: "ArialUnicodeMS",
      direction: "rtl",
      fill: "#000000",
      strokeWidth: 0.99905
    },
    className: "st4 st5 st7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 393.91069,139.35922 q 0,1.4323 -1.22396,2.96876 -1.06771,1.35416 -2.65625,2.33073 -1.51042,0.9375 -2.48698,0.9375 -0.89844,0 -1.94011,-0.26042 -0.79427,-0.19531 -1.90105,-0.61198 -0.9375,-0.35156 -1.86198,-0.70312 l 0.22136,-0.52084 q 0.85937,0.16927 1.78385,0.33855 0.93751,0.18229 1.69271,0.18229 1.66667,0 3.47657,-1.06771 1.64063,-0.97657 2.79948,-2.46094 1.15886,-1.4974 1.15886,-2.69532 0,-1.02865 -0.59896,-2.16146 -0.48177,-0.91146 -1.35417,-1.875 l 0.74219,-2.04428 q 1.06771,0.98959 1.57552,1.97917 0.57292,1.1198 0.57292,2.50001 z m -1.94011,-12.12241 -1.01562,1.88802 -2.10938,-1.09375 0.96354,-1.90104 z",
    style: {
      fontSize: "26.6667px"
    },
    id: "path132"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 380.87682,139.35922 h -7.42188 v -2.26563 h 6.47136 q 0,-1.53646 -0.36459,-2.34375 -0.24739,-0.55989 -1.22396,-1.61458 l 1.01563,-2.1224 q 0.9375,1.1849 1.17188,1.84896 0.35156,1.0026 0.35156,3.32032 z m -0.11719,2.57813 -0.96354,1.88802 -2.13542,-1.09375 0.98958,-1.88802 z m -2.96875,1.21094 -0.97657,1.86198 -2.14844,-1.10677 1.01563,-1.875 z",
    style: {
      fontSize: "26.6667px"
    },
    id: "path134"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 374.3664,139.35922 h -12.42189 q -2.50001,0 -3.98438,-0.87239 -1.86199,-1.09376 -1.86199,-3.42449 0,-1.21094 0.54688,-2.47396 0.19531,-0.45573 0.9375,-1.73177 l 0.39063,0.24739 q -0.28646,0.59896 -0.5599,1.19792 -0.3776,0.92448 -0.3776,1.65365 0,1.53646 1.61458,2.38282 1.44532,0.7552 3.65886,0.7552 h 11.02866 v -0.35156 q 0,-1.45833 -0.35156,-2.36979 -0.35157,-0.92448 -1.19792,-1.57553 l 1.0026,-2.12239 q 0.57292,0.71614 0.69011,0.89843 0.88542,1.45834 0.88542,4.2448 z m -6.13282,-11.83595 -0.96355,1.88802 -2.13542,-1.09375 0.98959,-1.88802 z m -2.96876,1.21094 -0.97656,1.86198 -2.14844,-1.10677 1.01563,-1.875 z",
    style: {
      fontSize: "26.6667px"
    },
    id: "path136"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.99904955,1.0009514)",
    id: "text36",
    style: {
      fontSize: "14.3971px",
      fontFamily: "ArialUnicodeMS",
      direction: "rtl",
      fill: "#000000",
      strokeWidth: 0.99905
    },
    className: "st4 st5 st7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 387.71138,175.61798 h -1.35416 q -0.8724,0 -1.96615,-0.39062 -1.26301,-0.45573 -2.22655,-1.25 -0.75521,0.92448 -1.54948,1.28906 -0.78125,0.35156 -2.29166,0.35156 h -2.03124 v -2.26562 h 1.99218 q 1.18489,0 2.10937,-0.59896 0.71614,-0.46874 1.30208,-1.3151 0.79427,-1.14583 1.95312,-1.99218 1.04166,-0.75521 1.91406,-0.96354 0.89843,1.36719 1.43228,2.46093 0.71615,1.48437 0.71615,2.40885 z m -1.49739,-2.5651 q -0.16927,-0.7552 -0.52084,-1.48437 -0.29947,-0.61198 -0.79426,-1.26302 -0.625,0.15625 -1.05469,0.58594 -0.28646,0.27344 -0.67708,0.92448 0.46875,0.50781 1.3151,0.91145 0.85937,0.40365 1.61458,0.49479 z",
    style: {
      fontSize: "26.6666px",
      strokeWidth: 0.99905
    },
    id: "path139"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 377.20359,175.61798 h -1.82291 q -0.88541,0 -1.41927,-0.71614 -0.46874,-0.625 -0.71614,-1.86198 -0.23437,-1.23697 -0.36458,-3.04687 -0.0781,-1.47135 -0.16927,-3.02082 -0.0781,-1.54948 -0.22136,-2.34375 -0.1302,-0.80728 -0.36458,-1.3151 -0.28646,-0.62499 -0.79427,-1.09374 l 1.60156,-2.52604 q 0.50781,1.5625 0.71614,3.73697 0.13021,1.35416 0.26042,6.40624 0.23438,2.3177 0.67708,2.96874 0.36459,0.54687 0.79427,0.54687 h 1.82291 z",
    style: {
      fontSize: "26.6666px",
      strokeWidth: 0.99905
    },
    id: "path141"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 369.76871,172.44091 -0.62499,2.13541 q -1.97917,0.49479 -3.2552,1.10676 -1.47135,0.70313 -2.68229,1.83594 l -0.40364,-0.22136 q 0.16927,-0.59895 0.45572,-1.10676 0.2474,-0.44271 0.57292,-0.79427 l -1.51041,-0.85938 q -0.66406,-0.4427 -0.66406,-0.96354 0,-0.41666 0.52083,-1.51041 0.625,-1.30208 1.43229,-2.17447 1.04166,-1.11979 2.09634,-1.11979 0.97656,0 1.61458,0.55989 0.14323,0.11719 0.66406,0.71615 l -0.67708,1.70572 q -0.48177,-0.32552 -0.57291,-0.39062 -0.79427,-0.50781 -1.30208,-0.50781 -0.625,0 -1.30208,0.35156 -0.67708,0.35156 -0.67708,0.79427 0,0.53385 0.78124,1.02864 0.61198,0.3776 1.84896,0.82031 1.80989,-0.87239 3.68488,-1.40624 z",
    style: {
      fontSize: "26.6666px",
      strokeWidth: 0.99905
    },
    id: "path143"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M572.3 112.8h-77.1v81h77.1v-81z",
    style: {
      fill: "#999"
    },
    id: "path38"
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M494.5 194.6H573v-82.4h-78.4v82.4m1.3-1.4v-79.7h75.8v79.7h-75.8z",
    id: "path40"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M546.6 85.3h2.6v-4.1h-31.1v4.1h2.5V95c0 1.5-.9 3.1-2.8 4.7-2.9 2.6-6.6 4.8-11.1 6.6-4.4 1.8-8 2.7-10.8 2.8h-.3l-.1.1c-1.8.5-2.8 1.7-2.9 3.6V196h81.7v-83.2c-.1-1.9-1.1-3.1-2.8-3.6l-.1-.1h-.3c-1.8 0-4-.5-6.8-1.3-4.3-1.4-8.2-3.2-12-5.7-1.8-1.1-3.3-2.3-4.3-3.6-1.1-1.3-1.6-2.5-1.6-3.6v-9.6m1.5-2.7V84h-2.6v11.1c.1 2 1.2 3.9 3.2 5.7 3.2 2.8 7 5.1 11.4 6.8 4.3 1.7 8 2.6 11.1 2.8v.1h.3c1.3.3 1.9 1.1 2 2.4v81.8h-79.1v-81.8c.1-1.3.8-2.1 2-2.4h.3c1.9-.1 4.2-.6 6.8-1.4 4.3-1.3 8.4-3.2 12.4-5.7 1.9-1.3 3.4-2.6 4.6-3.9 1.2-1.4 1.8-2.9 1.8-4.3V84h-2.5v-1.4h28.3z",
    id: "path42"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M543.5 88.5l1.7-3.9h-22.9l1.2 3.9h20z",
    className: "st3",
    id: "path44"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.99904953,1.0009514)",
    id: "text46",
    style: {
      fontSize: "14.3971px",
      fontFamily: "ArialUnicodeMS",
      direction: "rtl",
      fill: "#000000",
      strokeWidth: 0.99905
    },
    className: "st4 st5 st7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 548.07301,145.23338 h -1.35417 q -0.87239,0 -1.96615,-0.39062 -1.26302,-0.45573 -2.22656,-1.25 -0.75521,0.92448 -1.54948,1.28906 -0.78125,0.35156 -2.29167,0.35156 h -2.03125 v -2.26562 h 1.99219 q 1.18489,0 2.10937,-0.59896 0.71615,-0.46875 1.30209,-1.31511 0.79427,-1.14583 1.95313,-1.99219 1.04166,-0.75521 1.91406,-0.96354 0.89844,1.36719 1.43229,2.46094 0.71615,1.48438 0.71615,2.40886 z m -1.4974,-2.5651 q -0.16927,-0.75521 -0.52083,-1.48438 -0.29948,-0.61198 -0.79427,-1.26302 -0.625,0.15625 -1.05469,0.58593 -0.28646,0.27344 -0.67709,0.92449 0.46876,0.50781 1.31511,0.91145 0.85938,0.40365 1.61459,0.4948 z",
    style: {
      fontSize: "26.6667px"
    },
    id: "path146"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 537.56518,145.23338 h -1.82291 q -0.88542,0 -1.41928,-0.71614 -0.46875,-0.625 -0.71614,-1.86198 -0.23438,-1.23699 -0.36459,-3.04688 -0.0781,-1.47136 -0.16927,-3.02084 -0.0781,-1.54948 -0.22135,-2.34375 -0.13021,-0.8073 -0.36459,-1.31511 -0.28646,-0.625 -0.79427,-1.09375 l 1.60157,-2.52605 q 0.50781,1.56251 0.71614,3.73699 0.13021,1.35417 0.26042,6.40626 0.23437,2.31771 0.67708,2.96875 0.36459,0.54688 0.79428,0.54688 h 1.82291 z",
    style: {
      fontSize: "26.6667px"
    },
    id: "path148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 530.13028,142.0563 -0.625,2.13542 q -1.97917,0.49479 -3.25521,1.10677 -1.47136,0.70312 -2.6823,1.83594 l -0.40365,-0.22136 q 0.16928,-0.59896 0.45573,-1.10677 0.2474,-0.44271 0.57292,-0.79427 l -1.51042,-0.85938 q -0.66406,-0.44271 -0.66406,-0.96354 0,-0.41667 0.52083,-1.51042 0.625,-1.30208 1.4323,-2.17448 1.04167,-1.11979 2.09635,-1.11979 0.97657,0 1.61459,0.55989 0.14323,0.11719 0.66406,0.71615 l -0.67708,1.70573 q -0.48177,-0.32552 -0.57292,-0.39062 -0.79427,-0.50782 -1.30208,-0.50782 -0.625,0 -1.30209,0.35157 -0.67708,0.35156 -0.67708,0.79427 0,0.53385 0.78125,1.02864 0.61198,0.37761 1.84896,0.82032 1.8099,-0.8724 3.6849,-1.40625 z",
    style: {
      fontSize: "26.6667px"
    },
    id: "path150"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.99904953,1.0009514)",
    id: "text48",
    style: {
      fontSize: "14.3971px",
      fontFamily: "ArialUnicodeMS",
      direction: "rtl",
      fill: "#000000",
      strokeWidth: 0.99905
    },
    className: "st4 st5 st7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 557.96705,168.98398 q 0,2.14844 -1.58854,4.27084 -1.77084,2.36979 -4.08855,2.36979 -0.85937,0 -1.77083,-0.19531 -0.66407,-0.14323 -1.73178,-0.49479 -0.84635,-0.29948 -1.69271,-0.58594 l 0.22136,-0.45573 q 0.72916,0.16927 1.52344,0.35156 0.80729,0.19531 1.44531,0.19531 1.58854,0 3.00782,-0.80729 1.10677,-0.63802 2.21354,-1.84896 0.5599,-0.61198 1.58855,-1.99219 -1.75782,0 -2.63022,-0.5599 -0.98958,-0.63802 -0.98958,-2.09635 0,-1.34115 0.625,-2.48699 0.72917,-1.32812 1.84896,-1.32812 1.13281,0 1.62761,1.3151 0.39062,1.02865 0.39062,2.86459 z m -0.82031,-1.41928 q -0.28646,-1.25 -0.69011,-1.73177 -0.35156,-0.41667 -0.85937,-0.41667 -0.36459,0 -0.63802,0.2474 -0.26042,0.23438 -0.26042,0.59896 0,0.63802 0.57292,0.97656 0.57291,0.32552 1.875,0.32552 z",
    style: {
      fontSize: "26.6667px"
    },
    id: "path153"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 546.4436,169.76523 q 0,1.43229 -1.22396,2.96875 -1.06771,1.35417 -2.65625,2.33073 -1.51042,0.93751 -2.48699,0.93751 -0.89843,0 -1.9401,-0.26042 -0.79427,-0.19531 -1.90105,-0.61198 -0.9375,-0.35156 -1.86198,-0.70313 l 0.22136,-0.52083 q 0.85937,0.16927 1.78385,0.33854 0.9375,0.18229 1.69271,0.18229 1.66667,0 3.47657,-1.06771 1.64063,-0.97656 2.79948,-2.46094 1.15886,-1.4974 1.15886,-2.69531 0,-1.02865 -0.59896,-2.16146 -0.48177,-0.91146 -1.35417,-1.87501 l 0.74219,-2.04427 q 1.06771,0.98958 1.57552,1.97917 0.57292,1.11979 0.57292,2.5 z m -1.94011,-12.12241 -1.01562,1.88802 -2.10938,-1.09375 0.96354,-1.90104 z",
    style: {
      fontSize: "26.6667px"
    },
    id: "path155"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 533.40973,169.76523 h -7.42189 v -2.26563 h 6.47137 q 0,-1.53646 -0.36459,-2.34375 -0.24739,-0.5599 -1.22396,-1.61459 l 1.01563,-2.1224 q 0.9375,1.1849 1.17188,1.84896 0.35156,1.00261 0.35156,3.32032 z m -0.11719,2.57813 -0.96354,1.88802 -2.13542,-1.09375 0.98958,-1.88802 z m -2.96875,1.21094 -0.97657,1.86198 -2.14844,-1.10677 1.01563,-1.87501 z",
    style: {
      fontSize: "26.6667px"
    },
    id: "path157"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 526.89931,169.76523 h -12.42189 q -2.50001,0 -3.98438,-0.8724 -1.86199,-1.09375 -1.86199,-3.42448 0,-1.21094 0.54688,-2.47396 0.19531,-0.45573 0.9375,-1.73178 l 0.39063,0.2474 q -0.28646,0.59896 -0.5599,1.19792 -0.37761,0.92448 -0.37761,1.65365 0,1.53646 1.61459,2.38281 1.44531,0.75521 3.65886,0.75521 h 11.02866 v -0.35156 q 0,-1.45834 -0.35156,-2.3698 -0.35157,-0.92448 -1.19792,-1.57552 l 1.0026,-2.1224 q 0.57292,0.71615 0.69011,0.89844 0.88542,1.45834 0.88542,4.2448 z m -6.13282,-11.83595 -0.96355,1.88802 -2.13542,-1.09375 0.98959,-1.88803 z m -2.96876,1.21094 -0.97656,1.86198 -2.14844,-1.10678 1.01562,-1.875 z",
    style: {
      fontSize: "26.6667px"
    },
    id: "path159"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M587.8 207.6v-12.4H162.1v12.4h425.7z",
    style: {
      fill: "#bfbfbf"
    },
    id: "path50"
  }), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M588.5 208.3v-13.7h-427v13.7h427m-1.3-12.3v11H162.8v-11h424.4z",
    id: "path52"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M225.2 215.8c-2.4-2.4-5.2-3.6-8.6-3.6-3.4 0-6.3 1.2-8.7 3.6-2.4 2.4-3.6 5.3-3.6 8.7s1.2 6.3 3.6 8.7c2.4 2.4 5.3 3.6 8.7 3.6s6.2-1.2 8.6-3.6c2.4-2.4 3.6-5.3 3.6-8.7s-1.2-6.3-3.6-8.7z",
    className: "st6",
    id: "path54"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.99904951,1.0009514)",
    id: "text56",
    style: {
      fontSize: "11.4815px",
      fontFamily: "ArialUnicodeMS",
      fill: "#ffffff",
      strokeWidth: 0.99905
    },
    className: "st1 st7 st8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 215.73976,229.15019 v -8.62628 q -0.29948,0.29948 -1.01562,0.67057 -0.70963,0.3711 -1.3151,0.52084 v -1.25 q 0.80078,-0.22136 1.71223,-0.70312 0.91146,-0.48828 1.39974,-0.91797 h 0.48177 v 10.30596 z",
    style: {
      fontSize: "13.3333px"
    },
    id: "path107"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M383.7 215.8c-2.4-2.4-5.2-3.6-8.6-3.6s-6.3 1.2-8.7 3.6c-2.4 2.4-3.6 5.3-3.6 8.7s1.2 6.3 3.6 8.7 5.3 3.6 8.7 3.6c3.4 0 6.2-1.2 8.6-3.6 2.4-2.4 3.6-5.3 3.6-8.7 0-3.4-1.2-6.3-3.6-8.7z",
    className: "st6",
    id: "path58"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.99904951,1.0009514)",
    id: "text60",
    style: {
      fontSize: "11.4815px",
      fontFamily: "ArialUnicodeMS",
      fill: "#ffffff",
      strokeWidth: 0.99905
    },
    className: "st1 st7 st8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 376.09308,221.7088 q 0,-0.8138 -0.51432,-1.27603 -0.51433,-0.46875 -1.39974,-0.46875 -0.625,0 -1.26302,0.31901 -0.63802,0.31901 -1.1914,0.91145 v -1.23697 q 0.49479,-0.51432 1.11979,-0.78776 0.63151,-0.27344 1.47786,-0.27344 1.36718,0 2.20051,0.73568 0.83333,0.72916 0.83333,1.97916 0,1.11328 -0.51432,1.92708 -0.50781,0.8138 -1.74478,1.66666 -1.26302,0.87239 -1.69271,1.25 -0.42317,0.3776 -0.59245,0.72265 -0.16927,0.34505 -0.16927,0.83984 h 5.01301 v 1.13281 h -6.34113 v -0.5013 q 0,-0.87239 0.23438,-1.47786 0.24088,-0.61198 0.78776,-1.18489 0.54687,-0.57943 1.70572,-1.38672 1.18489,-0.83333 1.61458,-1.45833 0.4362,-0.63151 0.4362,-1.43229 z",
    style: {
      fontSize: "13.3333px"
    },
    id: "path110"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M544.6 215.8c-2.4-2.4-5.2-3.6-8.6-3.6-3.4 0-6.3 1.2-8.7 3.6-2.4 2.4-3.6 5.3-3.6 8.7s1.2 6.3 3.6 8.7c2.4 2.4 5.3 3.6 8.7 3.6s6.2-1.2 8.6-3.6c2.4-2.4 3.6-5.3 3.6-8.7 0-3.4-1.2-6.3-3.6-8.7z",
    className: "st6",
    id: "path62"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.99904951,1.0009514)",
    id: "text64",
    style: {
      fontSize: "11.4815px",
      fontFamily: "ArialUnicodeMS",
      fill: "#ffffff",
      strokeWidth: 0.99905
    },
    className: "st1 st7 st8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 532.52416,227.464 q 1.03515,0.80078 2.33723,0.80078 1.04167,0 1.64713,-0.50781 0.61198,-0.51433 0.61198,-1.3737 0,-1.91406 -2.74088,-1.91406 h -0.83984 v -1.05468 h 0.80078 q 2.42838,0 2.42838,-1.79687 0,-1.66015 -1.85546,-1.66015 -1.0612,0 -1.9987,0.71614 v -1.20442 q 0.98958,-0.57292 2.3112,-0.57292 1.28905,0 2.0703,0.67708 0.78125,0.67057 0.78125,1.74479 0,1.97916 -2.01822,2.54557 v 0.026 q 1.09374,0.11719 1.72525,0.77474 0.63802,0.65104 0.63802,1.6276 0,1.36067 -0.98307,2.194 -0.97656,0.83333 -2.60416,0.83333 -1.43229,0 -2.31119,-0.53385 z",
    style: {
      fontSize: "13.3333px"
    },
    id: "path113"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItem5Ar);
export default __webpack_public_path__ + "static/media/item5ar.1a6e6612bf21cc4b1b5aea04672a50a4.svg";
export { ForwardRef as ReactComponent };